import { ReactNode, useState } from 'react';

import CardStack from '../../../components/CardStack/CardStack';
import Form from '../../../components/Form/Form';
import ScrollToLastMounted from '../../../components/ScrollToLastMounted/ScrollToLastMounted';

import BookingParameterFields from './components/BookingParameterFields/BookingParameterFields';
import NumberOfBoatsCard from './components/NumberOfBoatsCard/NumberOfBoatsCard';
import PickupDateCard from './components/PickupDateCard/PickupDateCard';
import useFetchDates from './hooks/useFetchDates';
import useRequestedDates from './hooks/useRequestedDates';
import BookingFormLayout from './layouts/BookingFormLayout';
import ComposeBookingLayout from './layouts/ComposeBookingLayout';
import ComposeBookingProps from './types/pageProps/ComposeBookingProps';

type NumberOfBoatsViewProps = {
    max: number | null;
} & ComposeBookingProps;

const NumberOfBoatsView = ({
    max,
    parameters = {},
    nextStepUrl,
    errors,
}: NumberOfBoatsViewProps) => {
    const [dimCard, setDimCard] = useState(false);
    const fetchDates = useFetchDates(nextStepUrl, parameters);
    const requestedDates = useRequestedDates(parameters);

    return (
        <Form action={nextStepUrl} inertiaOptions={{ preserveScroll: true }}>
            <BookingParameterFields parameters={parameters} />

            <ScrollToLastMounted offset={-50}>
                <CardStack noDecoration>
                    <PickupDateCard
                        isFirst={false}
                        value={requestedDates}
                        onChange={fetchDates}
                        onInteractingWithDatePicker={setDimCard}
                    />

                    {max !== null && (
                        <NumberOfBoatsCard
                            dimmed={dimCard}
                            parameters={parameters}
                            max={max}
                            errors={errors}
                        >
                            <ScrollToLastMounted.Point
                                deps={[
                                    requestedDates?.pickupDate,
                                    requestedDates?.returnDate,
                                ]}
                            />
                        </NumberOfBoatsCard>
                    )}
                </CardStack>
            </ScrollToLastMounted>
        </Form>
    );
};

NumberOfBoatsView.layout = (page: ReactNode) => (
    <BookingFormLayout>
        <ComposeBookingLayout currentStep="numberOfBoats">
            {page}
        </ComposeBookingLayout>
    </BookingFormLayout>
);

export default NumberOfBoatsView;
